import { __exports as t } from "../../../../_virtual/isVisible.mjs";
Object.defineProperty(t, "__esModule", {
  value: !0
});
var a = t.default = void 0;
a = t.default = function(e) {
  if (!e)
    return !1;
  if (e instanceof Element) {
    if (e.offsetParent)
      return !0;
    if (e.getBBox) {
      var r = e.getBBox(), n = r.width, f = r.height;
      if (n || f)
        return !0;
    }
    if (e.getBoundingClientRect) {
      var i = e.getBoundingClientRect(), o = i.width, u = i.height;
      if (o || u)
        return !0;
    }
  }
  return !1;
};
export {
  a as default
};
//# sourceMappingURL=isVisible.mjs.map
